const minin = {
  data() {
    return {
      rules: {
        predict_loading_date: [
          { required: true, message: "请选择装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请选择卸货日期", trigger: "blur" },
        ],
      },
    };
  },
  methods: {},
  created() {
    this.formCtrlIn.map(v => {
      if (['coaddress', 'drman', 'drtel'].includes(v.keyName)) {
        v.viewMode = true
      }
    })
    this.formCtrlOut.map(v => {
      if (['enaddress', 'enman', 'ertel'].includes(v.keyName)) {
        v.viewMode = true
      }
    })
    this.formCtrlOrder.map(v => {
      if (['pricing_name', 'pricing_id', 'cprice', 'dprice'].includes(v.keyName)) {
        v.viewMode = true
      }
    })
  },
}

export default minin